var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1422 9.95216C12.1422 10.9692 11.3766 11.783 10.1474 11.783H10.1248C8.94129 11.783 8.17615 10.9692 8.17615 9.95216C8.17615 8.91359 8.96459 8.12256 10.1706 8.12256C11.3766 8.12256 12.1193 8.91359 12.1422 9.95216ZM11.9099 13.2288V23.8211H8.38458V13.2288H11.9099ZM24.6237 23.8211L24.6239 17.7479C24.6239 14.4944 22.8847 12.9801 20.5648 12.9801C18.6931 12.9801 17.8551 14.0082 17.3872 14.7295V13.2291H13.8614C13.9078 14.2231 13.8614 23.8214 13.8614 23.8214H17.3872V17.9058C17.3872 17.5893 17.4101 17.2735 17.5033 17.0468C17.7581 16.4144 18.3382 15.7596 19.3121 15.7596C20.5883 15.7596 21.0985 16.7309 21.0985 18.1543V23.8211H24.6237Z",
    fill: "#28292B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e09c62387fbb2efff9b522ab53a76bfd.svg";
export { ForwardRef as ReactComponent };